import * as React from 'react';
import type { SVGProps } from 'react';
export const SvgPylon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path
      d="M17.4 18H20v2H0v-2h2.6L8 0h4zm-3.2-4H5.8l-1.2 4h10.8zm-2.4-8H8.2L7 10h6z"
      fill="currentColor"
    />
  </svg>
);
